import { knowledgeApi } from '../../supportApi';

const CACHE_MS = 30 * 1000;

/** @type {{ tenantId: string, userId: string, data: object, at: number } | null} */
let memoryCache = null;
/** @type {Promise<object> | null} */
let inflight = null;

/**
 * Dedupes parallel preferences/get calls (feed view mode + shell nav use the same endpoint).
 * @param {string} [userId]
 * @param {string} [tenantId]
 */
export async function getDiscussionPreferencesCached(userId, tenantId) {
  const uid = String(userId || '').trim();
  const tid = String(tenantId || '').trim();
  if (!uid || !tid) {
    return { feedViewMode: null, shellNavCollapsed: false, defaultComposeMode: null };
  }
  const now = Date.now();
  if (
    memoryCache &&
    memoryCache.userId === uid &&
    memoryCache.tenantId === tid &&
    now - memoryCache.at < CACHE_MS
  ) {
    return memoryCache.data;
  }
  if (inflight) return inflight;

  inflight = knowledgeApi
    .discussionsPreferencesGet()
    .then((data) => {
      const payload = {
        feedViewMode: data?.feedViewMode ?? null,
        shellNavCollapsed: data?.shellNavCollapsed === true,
        defaultComposeMode: data?.defaultComposeMode ?? null,
      };
      memoryCache = { tenantId: tid, userId: uid, data: payload, at: Date.now() };
      return payload;
    })
    .catch(() =>
      memoryCache?.userId === uid && memoryCache?.tenantId === tid
        ? memoryCache.data
        : { feedViewMode: null, shellNavCollapsed: false, defaultComposeMode: null }
    )
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export function invalidateDiscussionPreferencesCache() {
  memoryCache = null;
}
